import React, { useEffect } from "react";
import { ClientModel } from "../../../Models/ReduxModels/ClientDetails";
import UserProfile from "../../../Models/ReduxModels/UserProfileModel";
import { connect } from "react-redux";
import NewJourneyFramework from "../newJourneyFramework";
import { ImagesMapping } from "../../../Configurations/ImagesMapping";
import { getClientName } from "Utils/GeneralUtils";
import { OnBoardingConstants } from "../constants";
import { logEvents } from "../../../Services/EventService";
import { EVENT_TYPE } from "Services/EventService";
import { pushAllEventsToServer } from "Services/EventService";
import { getNextStartBoardingEvent } from "../../../Utils/GeneralUtils";

interface IProps {
  history: History;
  clientData: any;
  userProfileData: any;
  currentOnboardingPage: number;
  totalOnboardingPages: Array<String>;
}
const Profile: React.FC<IProps> = props => {
  let clientName = getClientName();

  const { userProfileData, currentOnboardingPage, totalOnboardingPages } =
    props;

  const handlePermissionClick = (e, type) => {
    let permissionconsent = false;

    if (type === "ok") {
      permissionconsent = true;
    }
    new UserProfile({
      id: "local",
      ...userProfileData,
      isFirstUse: userProfileData?.isFirstUse,
      dob: userProfileData?.dob,
      interests: userProfileData?.interests,
      permissions: {
        ...userProfileData?.permissions,
        profiling: permissionconsent
      },
      currentOnboardingPage: currentOnboardingPage + 1
    }).$save();

    nextPage(permissionconsent);
  };
  const nextPage = permissionconsent => {
    logEvents({ eventType: EVENT_TYPE.NEXT_PAGE_ONBOARDING });
    logEvents({
      eventType: EVENT_TYPE.ONBOARDING_PROFILE_PERMISSION_EXITED,
      profile: permissionconsent
    });
    const nextStartEvent = getNextStartBoardingEvent(
      currentOnboardingPage,
      totalOnboardingPages
    );
    if (nextStartEvent) {
      logEvents({ eventType: nextStartEvent });
    }
    pushAllEventsToServer();
  };

  return (
    <>
      <NewJourneyFramework
        heading={OnBoardingConstants.PROFILING_HEADING}
        subHeading={OnBoardingConstants.PROFILING_SUBHEADING}
        handlePermissionClick={handlePermissionClick}
        buttonOkText="Allow"
        onboardingImage={ImagesMapping[clientName].newOnboardingProfilingImage}
        imageAltText="profileHeroImg"
        buttonCancelText="Not now"
        showVodafoneIcon={true}
      />
    </>
  );
};

const mapStateToProps = (state: any) => {
  const clientData = ClientModel.getInsatnce("", state)?.props;
  const userProfileData = UserProfile.getInsatnce("local", state)?.props;
  const currentOnboardingPage = userProfileData.currentOnboardingPage;
  const totalOnboardingPages = userProfileData?.totalOnboardingPages;

  return {
    clientData,
    userProfileData,
    currentOnboardingPage,
    totalOnboardingPages
  };
};

export default connect(mapStateToProps)(Profile);
